import momentTimezone from 'moment-timezone';
import isEqual from 'lodash/isEqual';

import {
    DIGITAL_CONTENT_EMBED_PARAM,
    EVENT_TYPE,
    BrowserTypes,
} from './constants';

// Takes a modules and type name and look to see if there are any
// Returns true or false
export const hasModuleOfType = (modules = [], type) =>
    modules.filter((module) => module.type === type).length > 0;

export const isEmbedUrl = (url) =>
    url.indexOf(`${DIGITAL_CONTENT_EMBED_PARAM}=true`) != -1;

export const getDateTime = (locale, dateTime) => {
    momentTimezone.locale(locale);
    const localTimezone = momentTimezone.tz.guess(true);
    const dateTimeWithTimezone = dateTime
        ? momentTimezone.utc(dateTime)
        : momentTimezone.utc();

    return dateTimeWithTimezone.tz(localTimezone);
};

export const getExtraData = ({ event, ticketClasses = [] }) => {
    const extras = {};

    if (ticketClasses.length) {
        extras.ticket_classes = ticketClasses.join();
    }

    // If this is a repeating event then send extra params
    if (event.isSeries) {
        extras.start_date_utc = event.start.utc;
        extras.end_date_utc = event.end.utc;
    }

    return extras;
};

export const isWebinar = (eventType) =>
    eventType === EVENT_TYPE.ZOOM_EVENT_TYPE_WEBINAR;

const vimeoApiUrl = (url) => `https://vimeo.com/api/oembed.json?url=${url}`;

const fetchVimeoData = (url) =>
    fetch(vimeoApiUrl(url), {
        method: 'GET',
    })
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            } else {
                return null;
            }
        })
        .catch((error) => null);

export const getVimeoEmbedUrl = (url) =>
    fetchVimeoData(url).then((response) => {
        if (!response) return null;

        const { html, video_id } = response;

        if (video_id) return `https://player.vimeo.com/video/${video_id}`;
        if (html) return html.split('src="')[1].split(/[" >]/)[0];
    });

export const isNone = (value) =>
    value === undefined ||
    value === null ||
    String(value).toLowerCase() === 'none';

export const isZoomEmbedAvailable = (assetType, isRegistrationEnabled) => {
    const browser = getUserBrowser();
    const isValidBrowser = !isEqual(browser, BrowserTypes.internetExplorer);
    const isValidAssetType =
        (assetType === EVENT_TYPE.ZOOM_EVENT_TYPE_MEETING &&
            !isRegistrationEnabled) ||
        assetType === EVENT_TYPE.ZOOM_EVENT_TYPE_WEBINAR;

    return isValidAssetType && isValidBrowser;
};

export const getUserBrowser = () => {
    const agent = navigator.userAgent;
    let browser;

    if (agent.indexOf('Firefox') > -1) {
        browser = BrowserTypes.firefox;
    } else if (agent.indexOf('SamsungBrowser') > -1) {
        browser = BrowserTypes.samsungInternet;
    } else if (agent.indexOf('Opera') > -1 || agent.indexOf('OPR') > -1) {
        browser = BrowserTypes.opera;
    } else if (agent.indexOf('Trident') > -1) {
        browser = BrowserTypes.internetExplorer;
    } else if (agent.indexOf('Edge') > -1) {
        browser = BrowserTypes.edge;
    } else if (agent.indexOf('Chrome') > -1) {
        browser = BrowserTypes.chrome;
    } else if (agent.indexOf('Safari') > -1) {
        browser = BrowserTypes.safari;
    } else {
        browser = BrowserTypes.unknown;
    }

    return browser;
};
